import gql from "graphql-tag";

export const UNREGISTER_DEVICE = gql`
  mutation ($token: String!) {
    unregisterDevice(token: $token)
  }
`;
